module.exports = __webpack_public_path__ + "assets/pxl-diag-01.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/images/pxl-diag-01.png
// module id = 149
// module chunks = 0